import React, { Component } from 'react';
import { message, Modal } from 'antd';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import EditableCell from './EditableCell';
import $ from '../../../common/AjaxRequest';
import '../style/list.less';

class TemplateTable extends Component {
	state = {
		dataSource: [],
		columns: [],
		count: 0,
		loading: false,
		tableColumns: [],
		requiredMap: new Map(),
		moduleDefineCode: null,
		moduleDefineId: null,
	}

	getSaveParam = (rowDataOriginal) => {
		const rowData = JSON.parse(JSON.stringify(rowDataOriginal));
		const paramsObj = {
			newParams: '',
			postObj: {}
		};
		let indicatorCount = -1;
		const indicatorRowCount = {};
		const rowIndexObj = {};
		let newParams = ``;
		newParams += `?`;
		for (const key in rowData) {
			if (typeof (rowData[key]) === "object") {
				const rowCount = indicatorRowCount[rowData[key].moduleDefineCode]
				if (rowData[key]["operationTypeTemp"] == "DELETE" || rowData[key]["operationTypeTemp"] == "UPDATE" || rowData[key]["operationTypeTemp"] == "INSERT") {
					rowData[key]["operationType"] = rowData[key]["operationTypeTemp"];
				}
				if (rowData[key].operationType != null && rowData[key].operationType != undefined) {
					if (rowCount >= 0) {
						indicatorRowCount[rowData[key].moduleDefineCode] = indicatorRowCount[rowData[key].moduleDefineCode] + 1;
					} else {
						indicatorRowCount[rowData[key].moduleDefineCode] = 0;
						indicatorCount++;
						rowIndexObj[rowData[key].moduleDefineCode] = indicatorCount;
					}
					for (const keySec in rowData[key]) {

						if (keySec == "rowNum" && rowData[key]["realRowNum"]) {
							paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key]["realRowNum"];
						} else {
							paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key][keySec] ? rowData[key][keySec] : '';
						}
					}
					paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicatorCode`] = rowData[key].moduleDefineCode;
				}
			} else {
				newParams += '&' + key + '=' + rowData[key];
			}
		}
		paramsObj.newParams = newParams;
		return paramsObj;
	}

	rowSave = (record, index) => {
		const { typeName, visitGroupingId } = this.props;
        const { requiredMap } = this.state;
		for (let [key, value] of requiredMap) {
			if (record[key] == undefined || record[key] == "") {
                if (requiredMap.get(key) == "患者编号") {
					Modal.error({ title: `请选择您录入的${requiredMap.get(key)}` });
					return;
				} else {
                    Modal.error({ title: `请输入${requiredMap.get(key)}` });
					return;
				}
			} else if (record[key]) {
				if (record[key]['value'] == "" || record[key]['value'] == undefined) {
					Modal.error({ title: `请输入${requiredMap.get(key)}` });
					return;
				}
			}
		}
		const paramsObj = this.getSaveParam(record);
		this.setState({ loading: true });
		const options = {
			url: `${API_URL.execute.save}${paramsObj.newParams}`,
			data: {
				...paramsObj.postObj,
				typeName,
				visitGroupingId,
			},
			method: 'post',
			dataType: 'json',
			doneResult: (data => {
				if (!data.error) {
					const { dataSource } = this.state;
					record.key = record.key + "saveSuccess";
					for (var key in record) {
						if (record && record.child !== 1) {
							if (record[key]["operationTypeTemp"] == "INSERT" || record[key]["operationTypeTemp"] == "UPDATE" || record[key]["operationTypeTemp"] == "DELETE") {
								dataSource[index][key]["operationType"] = dataSource[index][key]["operationTypeTemp"];
								dataSource[index][key]["operationTypeTemp"] = "";
							}
						} else {
							const dataIndex = this.getFatherIndex(record);
							if (record[key]["operationTypeTemp"] == "INSERT" || record[key]["operationTypeTemp"] == "UPDATE" || record[key]["operationTypeTemp"] == "DELETE") {
								dataSource[dataIndex]['children'][index][key]["operationType"] = dataSource[dataIndex]['children'][index][key]["operationTypeTemp"];
								dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "";
							}
						}
					}

					const clearOperationType = (obj) => {
						for (const key in obj) {
							if (obj[key] && obj[key]["operationType"]) {
								delete obj[key]["operationType"];
							}
							if (obj[key] && obj[key]["operationTypeTemp"]) {
								delete obj[key]["operationTypeTemp"];
							}
						}
						return obj
					}

					if (record && record.child !== 1) {
						if (data.rowNum) {
							dataSource[index].patientUserId = data.patientUserId;
							dataSource[index].rowNum = data.rowNum;
							dataSource[index] = clearOperationType(dataSource[index]);
						}
						dataSource[index]["isSave"] = false;
					} else {
						const dataIndex = this.getFatherIndex(record);
						if (data.rowNum) {
							dataSource[dataIndex]['children'][index].patientUserId = data.patientUserId;
							dataSource[dataIndex]['children'][index].rowNum = data.rowNum;
							dataSource[dataIndex]['children'][index] = clearOperationType(dataSource[dataIndex]['children'][index]);
						}
						dataSource[dataIndex]['children'][index]["isSave"] = false;
					}
					message.success('保存成功');
					this.setState({
						dataSource,
						loading: false
					}, () => {
						this.props.loadData();
					});
                }
			}),
			errorResult: (() => {
				this.setState({ loading: false });
			}),
			failResult: (() => {
				this.setState({ loading: false });
			})
		};
		$.sendRequest(options);
    }

	rowDelete = (record, index) => {
		if (record.patientUserId == -1 || record.rowNum == undefined) {
			const { dataSource } = this.state;
			dataSource.splice(index, 1);
			this.setState({ dataSource }, () => {
				if (dataSource.length == 0) {
					const { tableColumns } = this.state;
					const { columns } = this.convertColumns(tableColumns);
					this.setState({ columns });
				}
			});
			message.success('删除成功');
			return;
        }
        const { typeName } = this.props;
		let newParams = ``;
		newParams += `?typeName=${typeName}`;
		newParams += `&patientUserId=${record.patientUserId}`
		newParams += `&rowNum=${record.rowNum}`;
		this.setState({ loading: true });

		const options = {
			url: `${API_URL.execute.deleteCrfRowData}${newParams}`,
			data: {},
			dataType: 'json',
			doneResult: (data => {
				const dataSource = [...this.state.dataSource];
				if (record && record.child !== 1) {
					dataSource.splice(index, 1);
				} else {
					const dataIndex = this.getFatherIndex(record);
					dataSource[dataIndex]['children'].splice(index, 1);
					if (dataSource[dataIndex]['children'].length == 0) {
						dataSource.splice(dataIndex, 1);
					}
				}

				this.setState({ dataSource, loading: false }, function () {
					if (dataSource.length == 0) {
						const { tableColumns } = this.state;
						const { columns } = this.convertColumns(tableColumns);
						this.setState({ columns });
					}
				});
				message.success('删除成功');
			}),
			errorResult: (data => {
				this.setState({ loading: false });
			}),
			failResult: (data => {
				this.setState({ loading: false });
			})
		};
		$.sendRequest(options);
	}

    convertColumns = (tableColumns) => {
		tableColumns = [...tableColumns];
		const { codeList } = this.props;
		const { dataSource } = this.state;
		const dataEmpty = dataSource.length === 0;
        const requiredMap = new Map();
        this.loopTableColumns(tableColumns, tableColumns, requiredMap, dataEmpty, codeList);
        this.setState({ requiredMap });
        const { siteId, curRole } = sessionStorage;
		const canEdit = (siteId > 0 && curRole == 'CRC') || (curRole == 'PM' || curRole == 'PA');
		if (canEdit) {
			const opColumn = {
				title: '操作',
				dataIndex: 'operate',
				key: 'operate',
				fixed: 'right',
                width: 100,
                data: {
                    moduleDefineCode: 'op',
                    moduleDefineName: '操作',
                    criteriaDataType: 'TEXT',
                },
				render: (text, record, index) => {
					if (record.children && record.children.length > 0) {
						return (<div className="editable-cell"> - </div>)
					} else {
						return (
							!dataEmpty &&
                            <div className="editable-cell">
                                {
                                    record.isSave ?
                                        <a onClick={() => this.props.canEditByInvStatus(() => this.rowSave(record, index))}>保存</a>
                                        :
                                        <a className="aDisabled">保存</a>
                                }
                                {
                                    (curRole == 'CRC' || curRole == 'PM') &&
                                    <span>
                                        <span className="ant-divider"></span>
                                        {
                                            record.deleteable == 1
                                            ?
                                                <a onClick={() => this.props.canEditByInvStatus(() => this.rowDelete(record, index))}>删除</a>
                                            :
                                                <a className="aDisabled">删除</a>
                                        }
                                    </span>
                                }
                            </div>
						);
					}
				},
			};
			tableColumns.push(opColumn);
        }
        return { columns: tableColumns };
    }

    loopTableColumns = (tableColumns, data, requiredMap, dataEmpty, codeList) => {
        data.forEach((item, itemIdx) => {
            delete item.colSpan;
            delete item.rowSpan;
            if (item.children && item.children.length > 0) {
                item.title = item.fieldName;
                this.loopTableColumns(tableColumns, item.children, requiredMap, dataEmpty, codeList);
            } else {
                const tableColumn = item.data;
                let title = tableColumn.moduleDefineName,
                    type = tableColumn.criteriaDataType,
                    webType = tableColumn.projectDefineWebType,
                    dataIndex = tableColumn.moduleDefineCode == "op" ? tableColumn.moduleDefineCode : tableColumn.moduleDefineCode + "_" + tableColumn.rowNum,
                    criteriaDefineId = tableColumn.criteriaDefineId,
                    fieldIsComment = tableColumn.fieldIsComment,
                    config = {
                        isEdit: true,
                        comment: {
                            iscomment: item.fieldIsComment === '1',
                        },
                        colorClass: "normal",
                        type: {
                            type: type,
                            webType: webType,
                            moduleDefineConstraintValue: tableColumn.moduleDefineConstraintValue,
                        },
                        ...item,
                        ...tableColumn,
                    };
				item.width = 160;
                if (title == '录入者') {
                    item.width = 80;
                }
                item.title = title;
                item.dataIndex = dataIndex;
                if (dataIndex !== "op" && title != '录入者' && fieldIsComment != 1 ) {
                    if (title == '患者编号' && itemIdx == 0) {
                        item.render = (text, record, index) => {
                            config.isEdit = true;
                            let isEdit = true;
                            if (record && record.editable == 0) {
                                isEdit = false;
                            }
                            if (text && text.editable == 0) {
                                isEdit = false;
                            }
                            let cellDom;
                            if (record.children && record.children.length > 0) {
                                cellDom = <div style={{ paddingLeft: '20px' }}>
                                    <EditableCell
                                        cellValue={text}
                                        onChange={this.onCellChange(index, dataIndex, criteriaDefineId, record, tableColumn)}
                                        onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
                                        config={config}
                                        isEdit={isEdit}
                                    />
                                </div>
                            } else {
                                cellDom = <EditableCell
                                    cellValue={text}
                                    onChange={this.onCellChange(index, dataIndex, criteriaDefineId, record, tableColumn)}
                                    onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
                                    config={config}
                                    isEdit={isEdit}
                                />
                            }
                            return ( !dataEmpty && cellDom )
                        }
                    } else {
                        item.render = (text, record, index) => {
                            let isEdit = true;
                            config.isEdit = true;
                            if (record && record.editable === 0) {
                                isEdit = false;
                            }
                            if (text && text.editable === 0) {
                                isEdit = false;
                            }
                            return (
                                !dataEmpty &&
                                <EditableCell
                                    cellValue={text}
                                    onChange={this.onCellChange(index, dataIndex, criteriaDefineId, record, tableColumn)}
                                    onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
                                    config={config}
                                    isEdit={isEdit}
                                />
                            )
                        }
                    }
                    if (tableColumn.moduleDefineIsRequired == "1") {
                        requiredMap.set(tableColumn.moduleDefineCode + "_" + tableColumn.rowNum, tableColumn.moduleDefineName)
                    }
                } else if (title == '录入者' && fieldIsComment != 1) {
                    const { moduleDefineCode, moduleDefineId } = tableColumn;
                    this.setState({
                        moduleDefineCode,
                        moduleDefineId
                    })
                    item.render = (text) => {
                        return text ? <div className="editable-cell">{text.value}</div> : null;
                    }
                } else if (fieldIsComment == 1) {
                    item.render = (text, record, index) => {
                        let isEdit = true;
                        config.isEdit = true;
                        if (record && record.editable === 0) {
                            isEdit = false;
                        }
                        if (text && text.editable === 0) {
                            isEdit = false;
                        }
                        return (
                            !dataEmpty &&
                            <EditableCell
                                cellValue={text}
                                onChange={this.onCellChange(index, dataIndex, criteriaDefineId, true, record, tableColumn)}
                                onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
                                config={config}
                                isEdit={isEdit}
                            />
                        )
                    }
                    if (tableColumn.moduleDefineIsRequired == "1") {
                        requiredMap.set(tableColumn.moduleDefineCode, tableColumn.moduleDefineName)
                    }
                }
            }
        });
    }

	handleTableChangePre = (params) => {
		const { dataSource } = this.state;
        let countNeedSave = 0;
        dataSource.map((value, index) => {
            if (value["isSave"] == true) {
                countNeedSave++;
            }
        })
        if (countNeedSave !== 0) {
            Modal.confirm({
                title: '数据尚未保存，确定不做保存继续当前操作吗？',
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    this.props.handleTableChange(params)
                },
            });
        } else {
            this.props.handleTableChange(params);
        }
	}

	convertDataSource = dataSource => {
		const data = [];
		let key = 0;
		dataSource.map(rowData => {
			const rowDataKey = Object.entries(rowData);
			rowDataKey.map(rowKeyValue => {
				if (Array.isArray(rowKeyValue[1])) {
					const fieldArray = rowKeyValue[1];
					fieldArray.map((field => {
						const newKeyName = rowKeyValue[0] + "_" + field.rowNum;
						const newFieldValue = field;
						rowData[newKeyName] = newFieldValue;
					}));
				}
			})

			rowData["key"] = rowData.key;
			key++;
			rowData["isSave"] = false;
			if (rowData.children && rowData.children.length > 0) {
				rowData.children.map(value => {
					const rowChildKey = Object.entries(value);
					rowChildKey.map(childKeyValue => {
						if (Array.isArray(childKeyValue[1])) {
							const fieldArray = childKeyValue[1];
							fieldArray.map((field => {
								const newKeyName = childKeyValue[0] + "_" + field.rowNum;
								const newFieldValue = field;
								value[newKeyName] = newFieldValue
							}))
						}
					})
					value["key"] = value.key;
					key++;
					value["isSave"] = false;
				})
			}
			data.push(rowData);
		});
        this.setState({ count: key });
		return { data };
	}

	getFatherIndex = (record) => {
		const { dataSource } = this.state;
		let dataIndex;
		dataSource.map((father, fatherIndex) => {
			if (father['children']) {
				father['children'].map((child) => {
					if (child.key == record.key) {
						dataIndex = fatherIndex;
					}
				})
			}
		})
		return dataIndex;
	}

	onCellChange = (index, key, criteriaDefineId, record, tableColumn) => {
		return (value, type) => {
			const { dataSource } = this.state;
			if ((record && record.child !== 1) || record.child == undefined) {
				if (!dataSource[index][key]) {
					dataSource[index][key] = {
                        comment: "",
                        criteriaDefineId: criteriaDefineId,
                        operationType: "",
                        value: "",
                        operationTypeTemp: "INSERT",
                        editable: 1,
                        moduleDefineCode: tableColumn.moduleDefineCode,
                        rowNum: tableColumn.rowNum,
                        realRowNum: dataSource[index]['rowNum'],
                    }
					if (type !== "comment") {
						if (value !== "") {
							dataSource[index][key]['value'] = value;
						}
					}
				} else {
					dataSource[index][key]["operationTypeTemp"] = "";
					if (value == "" || value == undefined) {
						dataSource[index][key]["operationTypeTemp"] = "DELETE";
					} else if (dataSource[index][key]["operationType"] == "INSERT") {
						dataSource[index][key]["operationTypeTemp"] = "UPDATE";
					} else if (dataSource[index][key]["operationType"] == "UPDATE" || dataSource[index][key]["operationType"] == undefined) {
						dataSource[index][key]["operationTypeTemp"] = "UPDATE";
					} else if (dataSource[index][key]["operationType"] == "" || dataSource[index][key]["operationType"] == "DELETE") {
						dataSource[index][key]["operationTypeTemp"] = "INSERT";
					}
				}
				dataSource[index][key][type] = value;
				dataSource[index]["isSave"] = true;
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (dataSource[dataIndex] && dataSource[dataIndex]['children'])
					if (!dataSource[dataIndex]['children'][index][key]) {
						dataSource[dataIndex]['children'][index][key] = {
                            comment: "",
                            criteriaDefineId: criteriaDefineId,
                            operationType: "",
                            value: "",
                            operationTypeTemp: "INSERT",
                            editable: 1,
                            moduleDefineCode: tableColumn.moduleDefineCode,
                            rowNum: tableColumn.rowNum,
                            realRowNum: dataSource[dataIndex]['children'][index]['rowNum'],
                        }
						if (type !== "comment") {
							if (value !== "") {
								dataSource[dataIndex]['children'][index][key]['value'] = value;
							}
						}
					} else {
						dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "";
						if (value == "" || value == undefined) {
							dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "DELETE";
						} else if (dataSource[dataIndex]['children'][index][key]["operationType"] == "INSERT") {
							dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "UPDATE";
						} else if (dataSource[dataIndex]['children'][index][key]["operationType"] == "UPDATE" || dataSource[dataIndex]['children'][index][key]["operationType"] == undefined) {
							dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "UPDATE";
						} else if (dataSource[dataIndex]['children'][index][key]["operationType"] == "" || dataSource[dataIndex]['children'][index][key]["operationType"] == "DELETE") {
							dataSource[dataIndex]['children'][index][key]["operationTypeTemp"] = "INSERT";
						}
					}
				dataSource[dataIndex]['children'][index][key][type] = value;
				dataSource[dataIndex]['children'][index]["isSave"] = true;
			}
			this.setState({ dataSource });
		};
	}

	onPatientCodeChange = (index, key, criteriaDefineId, record) => {
		return (value, type) => {
			const { dataSource } = this.state;
			if (record && record.child !== 1) {
				const rowObj = dataSource[index];
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[index].patientUserId = value.patientId;
				}
				dataSource[index].newPatientUserId = value.patientId;

			} else {
				const dataIndex = this.getFatherIndex(record);
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[dataIndex]['children'][index].patientUserId = value.patientId;
				}
				dataSource[dataIndex]['children'][index].newPatientUserId = dataSource[dataIndex]['children'][index].patientUserId;
			}
			this.setState({ dataSource });
		};
	}

	handleAdd = () => {
        const { count, dataSource, moduleDefineCode, criteriaDefineId } = this.state;
		const newData = {
			key: count + "new5efk",
			patientUserId: -1,
			isSave: true,
			editable: 1,
        };
        if (moduleDefineCode) {
            newData[moduleDefineCode] = {
                comment: "",
				criteriaDefineId: criteriaDefineId,
				operationType: "",
				operationTypeTemp: "INSERT",
				value: sessionStorage.userName,
				moduleDefineCode,
				rowNum: 1,
            };
        }
		this.setState({
			dataSource: [newData, ...dataSource],
			count: count + 1,
		}, function () {
			const { tableColumns } = this.state;
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns });
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ dataSource: [], columns: [], count: 0, pagination: this.props.pagination }, () => {
			const { tableColumns, tableDatas, loading } = nextProps;
			this.setState({
				dataSource: this.convertDataSource(tableDatas).data,
				tableColumns,
				loading,
			}, () => {
				const { columns } = this.convertColumns(tableColumns);
				this.setState({ columns })
			});
		})
	}

	componentDidMount () {
		const { tableColumns, tableDatas, loading, pagination } = this.props;
		this.setState({
			dataSource: this.convertDataSource(tableDatas).data,
			tableColumns,
			loading,
			pagination
		}, () => {
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns })
		});
	}

	render() {
        const { pagination } = this.props;
        const { dataSource, columns, loading } = this.state;
		return (
			<div>
				<TableC
					data={dataSource}
					onChange={this.handleTableChangePre}
					pagination={pagination}
					columns={columns}
					loading={loading}
					rowKey='key'
					className='table-cell-row crf-table'
				/>
			</div>
		);
	}
}

export default TemplateTable;


// WEBPACK FOOTER //
// ./src/components/execute/template/TemplateTable.js